import type { Wallpaper } from '@/types'

const compact = new Intl.NumberFormat('en', { notation: 'compact', maximumFractionDigits: 1 })
const full = new Intl.NumberFormat('en')

export const formatCount = (value: number): string => value < 1000 ? full.format(value) : compact.format(value)

export const formatNumber = (value: number): string => full.format(value)

export const pluralize = (count: number, singular: string, plural = `${singular}s`): string => count === 1 ? singular : plural

// Width divided by height, from the stored size when it exists, otherwise a sensible default for the device.
export const getAspectRatio = (wallpaper: Pick<Wallpaper, 'width' | 'height' | 'portrait'>): number => {
    if (wallpaper.width && wallpaper.height && wallpaper.width > 0 && wallpaper.height > 0) return wallpaper.width / wallpaper.height

    return wallpaper.portrait ? 9 / 16 : 16 / 10
}

export const getDeviceLabel = (portrait: boolean): string => portrait ? 'Phone' : 'Desktop'
